export const ROUTES = [
  {
    label: 'report_technical_failure',
    link: '',
  },
  {
    label: 'failure_notification_title',
    link: 'additional-functionalities/failure-notification',
  },
  {
    label: 'additional_functionalities',
    link: 'additional-functionalities',
  },
];
